import { Row, Col, Space, Table, Form, Select, Card } from "antd";
import React from "react";
import BannerCard from "../../common/components/BannerCard";
import CleanButton from "../../common/components/CleanButton";
import InputCurrency from "../../common/components/InputCurrency";
import Page from "../../common/components/Page";
import PageSummary from "../../common/components/PageSummary";
import PaymentForm from "./paymentForm";
import useTrafficPayment from "./useTrafficPayment";
import getConfigs from "../../GetConfigs";

const TrafficCriminalPayment = () => {
  const { Title, Content } = Page;
  const { paymentColumn, amountData, handleContinue, form, disableInput, AmountToPay, handleView, paymentData, amount, handleCancel, paymentTokenLoading } = useTrafficPayment();
  const configurations = getConfigs([
    "activePayProcessor",
    "ctTRCRPaymentDisclaimerTxt"
  ]);
    function disclaimerText() {
        const customText = configurations?.ctTRCRPaymentDisclaimerTxt;
        const defaultText = "<Font>The case information contained within this web site is generated from computerized records maintained by " + configurations?.ctCityName + ". While every effort is made to assure the data is accurate and current, it must be accepted and used by the recipient with the understanding that no warranties, expressed or implied, concerning the accuracy, reliability or suitability of this data have been made. The Court, Clerk of Court, their agents, and the developers of this web site assume no liability whatsoever associated with the use or misuse of the data contained herein. By accessing or using this Web site, you agree to the terms. </Font>"
        return  customText || defaultText;
    }
  return (
    <Page>
      <Title hideBreadcrumb={true} title="Make Court Payment" icon="money-check-alt" />
      <Content>
        <Row gutter={16}>

          <Col xl={6} lg={6} md={6} sm={24} xs={24}>
            <Space direction="vertical">
              <PageSummary.Title title={paymentData?.MAIN[0]?.CASE} subtitle={paymentData?.MAIN[0]?.NAME} />
              <PageSummary.Title subtitle={`Maximum Payment: $${paymentData?.MAIN[0]?.TOTOWED}`} />
              <PageSummary.Title subtitle={`Minimum Payment: $${paymentData?.MAIN[0]?.TOTMIN}`} />
            </Space>
          </Col>
          <Col xl={18} lg={18} md={18} sm={24} xs={24}>

            <Form layout="vertical" form={form}>
              <Row gutter={[16, 16]}>
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <BannerCard title="Payments Detail">
                    <br />
                    <Table scroll={{ x: 720 }} columns={paymentColumn} dataSource={paymentData?.LIST} />
                  </BannerCard>
                </Col>
                <br />
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Card>
                    {amountData && (
                      <Row gutter={[14, 14]}>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                          <Form.Item label="Amount to pay" name="amountToPay" rules={[{ required: true }]}>
                            <Select placeholder="Select an amount" onChange={handleView}>
                              <Select.Option value={AmountToPay.CURRENT_BALANCE}>Current Balance</Select.Option>
                              <Select.Option value={AmountToPay.MINIMUM_PAYMENT}>Minimum Balance</Select.Option>
                              <Select.Option value={AmountToPay.OTHER_AMOUNT}>Other Amount</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                          <Form.Item label="Amount" name="amount" rules={[{ required: true }]}>
                            <InputCurrency min={1} max={paymentData?.MAIN[0]?.TOTOWED} style={{ width: "100%" }} disabled={disableInput} />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {!amountData && <h3>PAYMENT AMOUNT: ${amount}</h3>}
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <div dangerouslySetInnerHTML={{ __html: disclaimerText() }} />
                  </Card>
                </Col>
                <Col>
                  {amountData && (
                    <CleanButton isLoading={paymentTokenLoading} onClick={handleContinue} icon="check-double">
                      Continue
                    </CleanButton>
                  )}
                  {!amountData && amount > 0 && configurations.activePayProcessor == "authorize" && <PaymentForm amount={amount} />}
                </Col>
                <Col>
                  <CleanButton onClick={handleCancel} icon="times">
                    Cancel
                  </CleanButton>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Content>
    </Page>
  );
};

export default TrafficCriminalPayment;
